import { render, staticRenderFns } from "./MsupplierIndex.vue?vue&type=template&id=6d616376"
import script from "./MsupplierIndex.vue?vue&type=script&lang=js"
export * from "./MsupplierIndex.vue?vue&type=script&lang=js"
import style0 from "./MsupplierIndex.vue?vue&type=style&index=0&id=6d616376&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports